/*
 * tcms_core.js - seo-admin
 * Copyright (c) CHECK24 Vergleichsportal Reise GmbH 2023.
 *
 * @author     Mark Kotsarev <mark.kotsarev@check24.de>
 * @modified   11.05.23, 10:03
 */
import './tcms_core_react.js';
import './tcms_core_helper.ts';
import './tcms_core_eventTracking.js';
import './tcms_core_dynamic_styles.js'; // Dynamische Styles, die nur bei Bedarf eingebunden werden

if (window.TCMS.trackingManager.eventTracking) {
    window.TCMS.trackingManager.eventTracking.addListeners();
}

if (window.performance && window.performance.mark === undefined) {
    window.performance.mark = function() {
    };
}

if (window.performance && window.performance.measure === undefined) {
    window.performance.measure = function() {
    };
}

if (window.TCMS.product === 'urlaub') {
    import('./tcms_core_urlaub_history_hack.js');
}

// Independent Resources
import('./tcms_core_backtotop');

const couponBarElems = document.querySelectorAll('.coupon-bar');

window.fireOnVisible(couponBarElems, async() => {
    await import('./tcms_core_cscode.js');
});

// Capture unhandled promise exceptions
window.addEventListener('unhandledrejection', function(event) {
    console.error('Unhandled rejection (promise: ', event.promise, ', reason: ', event.reason, ').');
});
// Capture handled rejections of promises without catch block
window.addEventListener('rejectionhandled', function(event) {
    console.error('Handled rejection (promise: ', event.promise, ', reason: ', event.reason, ').');
});

// Basic Information http://wicg.github.io/netinfo/
var navigator = window.navigator;

console.groupCollapsed('Device Information');

if ('connection' in navigator) {
    var _connection = navigator.connection;

    if ('saveData' in _connection) {
        console.log('Device has requested to save data: %s', _connection.saveData);
    }

    if ('type' in _connection) {
        console.log('Connection Type: %s', _connection.type);
    }

    if ('effectiveType' in _connection) {
        console.log('Effective Connection Type: %s', _connection.effectiveType);
    }

    if ('downlink' in _connection) {
        console.log('Effective Downlink: %s MBit/s', _connection.downlink);
    }

    if ('downLinkMax' in _connection) {
        console.log('Max Downlink: %s MBit/s', _connection.downLinkMax);
    }
}

if ('hardwareConcurrency' in navigator) {
    console.log('CPUs: %s', navigator.hardwareConcurrency);
}

if ('deviceMemory' in navigator) {
    console.log('Memory: %s GB', navigator.deviceMemory);
}
console.groupEnd();
